import { BaseRHFWidgetProps } from "@impero-com/common/components/form/rhfFields/types";
import { FieldValues, UseFormTrigger, useController } from "react-hook-form";

import { Guid } from "utils/guid";

import {
    EditableUserTagListPlusInput,
    EditableUserTagListInputBaseProps,
} from "../fields/editableUserTagListPlus";

export interface RHFEditableUserTagListInputProps<
    TFieldsValues extends FieldValues,
>
    extends
        BaseRHFWidgetProps<TFieldsValues, Guid[]>,
        EditableUserTagListInputBaseProps {
    // Needs to be supplied if there is validation on array level
    trigger?: UseFormTrigger<TFieldsValues>;
    // Side-effect callback
    onChange?: () => void;
}

export function RHFEditableUserTagListInput<TFieldsValues extends FieldValues>({
    name,
    control,
    disabled,
    label,
    canCreateTag,
    cascaderClassName,
    trigger,
    onChange,
}: RHFEditableUserTagListInputProps<TFieldsValues>) {
    const { field, fieldState } = useController({ name, control, disabled });

    const handleBlur = () => {
        field.onBlur();
        trigger?.(name); // RHF expects to use useFieldArray for arrays, with errors at item level
    };

    const handleSelect = (tagIds: Guid[]) => {
        field.onChange(tagIds);
        onChange?.();
    };

    return (
        <EditableUserTagListPlusInput
            inputRef={field.ref}
            onBlur={handleBlur}
            setSelectedTagIds={handleSelect}
            cascaderClassName={cascaderClassName}
            canCreateTag={canCreateTag}
            disabled={field.disabled}
            error={fieldState.error?.message}
            label={label}
            selectedTagIds={field.value}
        />
    );
}
